module.exports = __webpack_public_path__ + "assets/help-link.bdb63d36.svg";